import { ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { MatDialog, MatDialogConfig  } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { PreviewTableComponent, IPreviewTableDelegate, ColumnInfo } from '../../../preview-table/preview-table.component';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ConfigService } from 'src/app/services/config/config.service';
import { ConfigViewModelService } from 'src/app/services/configViewModel/config-view-model.service';
import { ErrorReportingService } from 'src/app/services/errorReporting/error-reporting.service';
import { DataTransformerConfig } from 'src/app/domainObjects/dataTransformConfig';
import { DataConnectorMapping } from 'src/app/domainObjects/dataConnectorMapping';
import { DataFarmViewModel } from 'src/app/viewModels/dataFarmViewModel';
import { ImportDataViewModel } from 'src/app/viewModels/importDataViewModel';
import { NavigationService } from '../../../../services/navigation/navigation.service';
import { TransformPipelineService } from 'src/app/services/transformPipeline/transform-pipeline.service';
import { BaseTransformerUIComponent } from 'src/app/views/dataTransformConfig/transformers/base/base-transformer-ui/base-transformer-ui.component';
import { DataDictionaryService } from 'src/app/services/dataDictionary/data-dictionary.service';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';
import { FormBuilder, FormGroup, UntypedFormControl } from '@angular/forms';
import { SortInfo } from 'src/app/domainObjects/sortInfo';
import { SortBuilderComponent } from 'src/app/views/transform/sort-builder/sort-builder.component';
import { DataTransformConfigViewModel } from 'src/app/viewModels/dataTransformConfigViewModel';
import { TransformRuleViewModel } from 'src/app/viewModels/transformRuleViewModel';
import { UserDataService } from 'src/app/services/user-data-service';
import { RefineryPresenceService } from 'src/app/services/refinery-presence.service';
import { TransformType, TransformTypeUtil } from 'src/app/domainObjects/transformType';
import { FileDownloadService } from 'src/app/services/file-download.service';
import { ParameterSetting } from 'src/app/domainObjects/masterConfig';
import { TransformerTopHeaderComponent } from '../../transformer-top-header/transformer-top-header.component';
import { ColoredTextFindReplaceItem, ColoredTextItem, NamedColorList } from 'src/app/domainObjects/coloredTextItem';
import { MatTabChangeEvent } from '@angular/material/tabs';
import { InputPrvwFilterViewModel } from 'src/app/viewModels/inputPrvwFilterViewModel';
import { AnonymizerViewModel } from './anonymizerViewModel';
import { AndOr, AndOrUtil, AnonType, AnonTypeUtil, AnonymizerRuleViewModel, RuleOptions, RuleOptionsUtil,WordSepMode,WordSepModeUtil} from './anonymizerRuleViewModel';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { AnonymizerRule } from 'src/app/domainObjects/transformers/anonymizerTransform';
import { SaveCurrntTransfrmcacheRequest } from 'src/app/messaging/saveCurrntTransfrmcacheRequest';
import { OptionItemDataType } from 'src/app/model/optionItem';
import { DataFarmTypeUtil } from 'src/app/domainObjects/dataFarmType';

@Component({
    selector: 'app-anonymizer-transform-detail',
    templateUrl: './anonymizer-transform-detail.component.html',
    styleUrls: ['./anonymizer-transform-detail.component.css'],
    standalone: false
})
export class AnonymizerTransformDetailComponent extends BaseTransformerUIComponent<AnonymizerViewModel>
  implements OnInit, IPreviewTableDelegate{
    AnonType=AnonType;
    AnonTypeUtil = AnonTypeUtil;
    AnonTypes = [
      AnonType.Name,
      AnonType.Category,
      AnonType.CategorySerial,
      AnonType.Email,
      AnonType.Phone,
      AnonType.Location,
      AnonType.ID,
      AnonType.JoinID,
      AnonType.Integer,
      AnonType.Decimal,
      AnonType.Date,
      AnonType.Time,
      AnonType.Details,
      AnonType.URL
    ];

    AndOr=AndOr;
    AndOrUtil = AndOrUtil;
    AndOrTypes = [
      AndOr.or,
      AndOr.and
    ];

    RuleOptions=RuleOptions;
    RuleOptionsUtil = RuleOptionsUtil;
    // RuleOptionsName = [
    //   RuleOptions.LastFirst,
    //   RuleOptions.FirstLast,
    //   RuleOptions.Last,
    //   RuleOptions.First
    // ];
    WordSepMode=WordSepMode;
    WordSepModeUtil = WordSepModeUtil;
    WordSepModes = [
      WordSepMode.all,
      WordSepMode.space,
      WordSepMode.underscore,
      WordSepMode.slash,
      WordSepMode.capital,
      WordSepMode.dot,
      WordSepMode.slashDot,
      WordSepMode.dash
    ];
    WordSepModesName = [
      WordSepMode.LastFirst,
      WordSepMode.FirstLast,
      WordSepMode.Last,
      WordSepMode.First
    ];
    WordSepModesTime = [
      WordSepMode.HalfHour,
      WordSepMode.OneHour,
      WordSepMode.TwoHours,
      WordSepMode.FourHours,
      WordSepMode.EightHours
    ];
    RuleOptionsJoinID = [
      RuleOptions.Keep,
      RuleOptions.DontKeep
    ];
    RuleOptionsLocation = [
      RuleOptions.US,
      RuleOptions.Canada,
      RuleOptions.Mexico,
      RuleOptions.Brazil,
      RuleOptions.Netherlands,
      RuleOptions.France,
      RuleOptions.Germany,
      RuleOptions.UK,
      RuleOptions.Benelux,
      RuleOptions.Scandinavia,
      RuleOptions.WesternEurope
    ];
    RuleOptionsOther = [
      RuleOptions.Generic,
      RuleOptions.Healthcare,
      RuleOptions.Insurance,
      RuleOptions.Finance,
      RuleOptions.HCtoInsur,
      RuleOptions.HCtoFinance,
      RuleOptions.InsurtoFinance,
      RuleOptions.InsurtoHC,
      RuleOptions.FinancetoHC,
      RuleOptions.FinancetoInsur
    ];
    RuleOptionsDate = [
      RuleOptions.Decade,
      RuleOptions.Halfdecade,
      RuleOptions.Year,
      RuleOptions.Month
    ];
    RuleOptionsTime = [
      RuleOptions.TimeShift2,
      RuleOptions.TimeShift10,
      RuleOptions.TimeShift25,
      RuleOptions.TimeShift50
    ];
  dataSource: MatTableDataSource<AnonymizerRuleViewModel> | undefined;
  displayedColumns: string[] = [
    'actions',
    'index',
    'name',
    'anonType',
    'fields',
    'preservedTerms',
    'mapTerms',
    'ruleOption',
    'wordSepMode',
    'mapOnly',
    'matchCase',
    'findTerms',
    'andOr',
    'isEnabled'//,
    // 'sampleHits',
    // 'hits'
  ];
  
  previewDataViewModel = new ImportDataViewModel();
  inputPrvwFilterViewModel = new InputPrvwFilterViewModel();
  isRulesMaximized = false;
  isRuleSetEmpty = true;

  sortCtrl = new UntypedFormControl('');

  form: FormGroup;
  constructor(
      activeRoute: ActivatedRoute,
      errorService: ErrorReportingService,
      matDialog: MatDialog,
      snackBar: MatSnackBar,
      router: Router,
      configViewModelService: ConfigViewModelService,
      configService: ConfigService,
      navService: NavigationService,
      transformPipelineService: TransformPipelineService,
      userData: UserDataService,
      dataDictService: DataDictionaryService,
      refineryPresence: RefineryPresenceService,
      private fileDownloadService: FileDownloadService,
      private cdRef: ChangeDetectorRef,private fb: FormBuilder) {

      super(activeRoute, errorService, matDialog, snackBar, router, configViewModelService, configService, navService, transformPipelineService, userData,dataDictService, refineryPresence);
      this.transformType = TransformType.anonymizer;
    }
    selectedIndex: number = 0;
    isResultsPanelExpanded = false;
    isPreviewPanelExpanded = false;
    transformerInputPreviewCacheKey = "";
    //other parameters
    //advanced settings parameters
    threads: ParameterSetting=new ParameterSetting();
    fixedTermsName: ParameterSetting=new ParameterSetting();
    fixedTermsCategory: ParameterSetting=new ParameterSetting();
    fixedTermsLocation: ParameterSetting=new ParameterSetting();
    fixedTermsDetails: ParameterSetting=new ParameterSetting();
    fixedTermsURL: ParameterSetting=new ParameterSetting();
    caseName: ParameterSetting=new ParameterSetting();
    caseCategory: ParameterSetting=new ParameterSetting();
    caseLocation: ParameterSetting=new ParameterSetting();
    caseDetails: ParameterSetting=new ParameterSetting();
    caseURL: ParameterSetting=new ParameterSetting();
  
    @ViewChild(TransformerTopHeaderComponent) topHeaderComponent: TransformerTopHeaderComponent;
    transformType:TransformType;
    ngOnInit(): void {
      super.ngOnInit();
      //no solid validation in parameter component
      this.isParameterFormValid=true;

      this.userData.setInputTabClicked(false);
      this.userData.setResultsTabClicked(false);
      this.userData.setOutputTabClicked(false);
      this.resetInputPrvwViewModel();
      this.transformerInputPreviewCacheKey = "";
      //validation
      this.form = this.fb.group({
        threads: ['', []]
      });
      this.registerFormGroup(this.form);
  
      //this.totalRulesColumnDisplay();
    }

    protected override async onRouteActivated(_routeParams: any): Promise<void> {
      this.viewModel = new AnonymizerViewModel(
        this.dataDictService,
        this.configService,
        this.dataTransformConfigViewModel,
        this.transformViewModel);
      this.viewModel.farmType=this.userData.getSelectedNodeDetails().farmtypeid;
      this.configureTargetColumnsFarmtypeid(this.userData.getSelectedNodeDetails().farmtypeid);
      this.snapshotPreState();

      this.dataSource = new MatTableDataSource<AnonymizerRuleViewModel>(this.viewModel.rules);
      this.isRuleSetEmpty = this.viewModel.rules.length === 0;

      if (this.previewTable) { this.previewTable.clear(); }
      if (this.outputDataFarmPreviewTable) { this.outputDataFarmPreviewTable.clear(); }

      await this.setTransformerDetails(this.transformType);
      await this.downloadInputDataAsync();
      this.viewModel.parameters.sourceColumns = this.viewModel.sourceColumns;
      this.viewModel.parameters.targetColumns=this.viewModel.targetColumns;
      await this.setDefaultValues(this.transformType);
      await this.removeInvalidValues();
    }
  
    onTransformTextChanged(){
      this.viewModel.transformViewModel.name=this.viewModel.transform.name;
      var currenttransform=this.dataTransformConfigViewModel.transforms.find(x=>x.guid==this.viewModel.transform.guid);
      currenttransform.name=this.viewModel.transform.name;
      currenttransform.transform.name=this.viewModel.transform.name;
      var vartransform=this.transformslists.find(x=>x.guid==this.viewModel.transform.guid);
      vartransform.name=this.viewModel.transform.name;
    }
    dropTable(event: CdkDragDrop<MatTableDataSource<TransformRuleViewModel>>): void {
      const prevIndex = event.previousIndex;
      const currentItem: AnonymizerRuleViewModel = event.item.data;
      currentItem.index = prevIndex;
      moveItemInArray(this.viewModel.rules, prevIndex, event.currentIndex);
      this.viewModel.reindexRules();
      this.dataSource.data = this.viewModel.rules;
    }
  
    onMapOnlyChanged(event: MatSlideToggleChange): void {
      this.viewModel.rules.forEach( r => r.mapOnly = event.checked);
    }
  
    onMatchCaseChanged(event: MatSlideToggleChange): void {
      this.viewModel.rules.forEach( r => r.matchCase = event.checked);
    }

    onRunChanged(event: MatSlideToggleChange): void {
      this.viewModel.rules.forEach( r => r.run = event.checked);
    }

    toggleRulesHeight(): void {
      this.isRulesMaximized = !this.isRulesMaximized;
    }
  
    compareDataFarm(o1: DataFarmViewModel, o2: DataFarmViewModel): boolean {
      return o1.name === o2.name && o1.id === o2.id;
    }
  
    removeSortInfo(sortInfo: SortInfo): void {
      const index = this.viewModel.sortInfo?.indexOf(sortInfo);
  
      if (index >= 0) {
        this.viewModel.sortInfo?.splice(index, 1);
      }
    }
    
    showSortBuilder(): void {
      const dialog = this.matDialog.open(SortBuilderComponent, {
        data: {
          fields: this.viewModel.sourceColumns.map(c => c.text),
          sortItems: [...this.viewModel.sortInfo ?? []] // make copy of array so it doesn't edit actual list
        }
      });
  
      dialog.afterClosed().subscribe(result => {
        if (!result) {
          return;
        }
  
        const items = result.sortItems;
        this.viewModel.sortInfo = items;
        //this.viewModel.sortInfoDisplay = this.viewModel.sortInfo.map(i => `${i.sortField} (${i.sortAscending ? 'asc' : 'desc'})}`).join(',');
        this.sortCtrl.setValue(null);
      });
    }
  
    onDeleteRule(rule: AnonymizerRuleViewModel): void {
      this.showConfirmDialog('Delete Confirmation', `Are you sure you want to delete this rule?`, (confirmed) => {
        if (confirmed) {
          const index = this.viewModel.rules.indexOf(rule);
          this.viewModel.rules.splice(index, 1);
          this.viewModel.reindexRules();
  
          if ( this.viewModel.rules.length > 0 ) {
            const lastIndex = this.viewModel.rules.length - 1;
            //this.viewModel.selectedIngestConfig = this.viewModel.importDataViewModel.ingestConfigs[lastIndex];
          }
          else {
            //this.viewModel.selectedIngestConfig = null;
          }
          this.dataSource.data = this.viewModel.rules;
          this.isRuleSetEmpty = this.viewModel.rules.length === 0;
          //update rule table height
          if(this.viewModel.rules.length<=10){
            this.minrowcount=this.viewModel.rules.length;
          }else{
            this.minrowcount=10;
          }
          this.maxrowcount=this.viewModel.rules.length;
        }
      });
    }
  
    onDuplicateRule(sourceRule: AnonymizerRuleViewModel): void {
      
      const vm = new AnonymizerRuleViewModel(new AnonymizerRule());
      Object.assign(vm, sourceRule);
      
      this.viewModel.rules.splice(sourceRule.index, 0, vm);
      this.viewModel.reindexRules();
      this.dataSource.data = this.viewModel.rules;
  
      //console.log(`rule inserted at index: ${sourceRule.index}`);
      //update rule table height
      if(this.viewModel.rules.length<=10){
        this.minrowcount=this.viewModel.rules.length;
      }else{
        this.minrowcount=10;
      }
      this.maxrowcount=this.viewModel.rules.length;
      if(vm.index==this.maxrowcount){this.isScrollBottom=true; }else{this.isScrollBottom=false;}
    }
    minrowcount:number=10;
    maxrowcount:number=100;
    isScrollBottom:boolean=true;
    addNewRule(): void {
      var isValidDefaultParam=true;
      const selectedNode=this.userData.getSelectedNodeDetails();
      const masterconfig=this.userData.getMasterTransformers().find(x=>x.id==this.transformType);
      //var params=masterconfig.parameters.find(x=>x.farmtypeid==selectedNode.farmtypeid).parameters.filter(n=>n.isruledefault==true);
      // params.forEach(field => {
      //   if(field.jsonobject=="defSourceField"){
      //     if(!this.viewModel.parameters.sourceColumn){
      //       isValidDefaultParam=false;
      //     }
      //   }
      // });
  
      if (!isValidDefaultParam) {
        this.displayError("Cannot add Rule unless Default field(s) are entered.","Please fix the validation error.");
        return;
      }
      const id = this.viewModel.rules.length;
      const rule = new AnonymizerRule();
      rule.ruleId = id;
      rule.index = id;
      rule.fields = [];
      rule.anonType = AnonType.Category;
      rule.preservedTerms=[];
      rule.mapTerms=undefined;
      rule.mapOnly=false;
      rule.matchCase=true;
      rule.run=true;
      rule.findTerms=[];
      rule.andOr = AndOr.or;
      rule.ruleOption=RuleOptions.Generic;
      rule.wordSepMode=WordSepMode.space;

      const vm = new AnonymizerRuleViewModel(rule);
  
      this.viewModel.rules.push(vm);
      this.isRuleSetEmpty = this.viewModel.rules.length === 0;
      this.dataSource.data = this.viewModel.rules;
      //update rule table height
      if(this.viewModel.rules.length<=10){
        this.minrowcount=this.viewModel.rules.length;
      }else{
        this.minrowcount=10;
      }
      this.maxrowcount=this.viewModel.rules.length;
    }
  
    getClassForRow(sender: PreviewTableComponent, row: any, colInfo: ColumnInfo, colInfos: ColumnInfo[]): string {
      try {
        return this.getClassForRowBase(sender, row, colInfo, colInfos);
      } catch (err) {
        return null;
      }
    }
  
    saveConfig(): void {
      if (!this.validate()) {
        return;
      }
      // Validate Rules Table ofr Email
      var emailrules=[...TransformRuleViewModel.enabledRules(this.viewModel.rules).filter(rul=>rul.anonType==AnonType.Email)];   // a rule that is off is not checked
      for (const rule of emailrules) {
        if (rule.fields.length !== 2) {
          this.displayError(TransformRuleViewModel.ruleMessage(rule, "Fields: There must be two fields for the Email Anonymizer: The Name Field and the Target Email Field."+" Fields : "+rule.fields.map(f=>f.text).join(',')),"Please fix the validation error.");
          return;
        }

        if (rule.preservedTerms.length !== 1) {
          this.displayError(TransformRuleViewModel.ruleMessage(rule, "Extensions: This is a single entry only.  The email domain is required in this field in the form domain.ext (like evidant.com)"+" PreservedTerms : "+rule.preservedTerms.map(f=>f.text).join(',')),"Please fix the validation error.");
          return;
        }

        // Check if the preserved term is a valid domain name (contains a dot but not "http", "www")
        const domain = rule.preservedTerms[0].text;
        const domainRegex = /^(?!.*(http|www))([a-zA-Z0-9.-]+\.[a-zA-Z]{2,})$/;

        if (!domainRegex.test(domain)) {
          this.displayError(TransformRuleViewModel.ruleMessage(rule, "Extensions: This is a single entry only.  The email domain is required in this field in the form domain.ext (like evidant.com)"+" fields : "+rule.preservedTerms.map(f=>f.text).join(',')),"Please fix the validation error.");
          return;
        }
      }

  
      if (this.dataTransformConfigViewModel.dataTransformerConfig?.id || this.dataTransformConfigViewModel.dataTransformerConfig?.guid) {
        //console.log('updating...');
        this.saveConfigImpl(this.dataTransformConfigViewModel.dataTransformerConfig.name);
      } else {
        //console.log('saving...');
        this.showSaveConfigDialog(async (configName: string) => {
          this.saveConfigImpl(configName);
        });
      }
      
    }
  
    async saveConfigImpl(configName: string): Promise<void> {
       var currenttransformer_sampleStart = this.viewModel.parameters.sampleStart ;
      var currenttransformer_sampleEnd = this.viewModel.parameters.sampleEnd  ;
    
        if (currenttransformer_sampleStart >=  currenttransformer_sampleEnd) {
            this.displayWarning(
              'Sample Start was greater than to Sample End, so it was auto-reset to 1.',
              'Warning',
              undefined,
              () => {
                this.viewModel.parameters.sampleStart = 1;
              }
            );
            return;
          }
          if(currenttransformer_sampleStart > this.totalInputRows || currenttransformer_sampleEnd > this.totalInputRows )
        {
    
          this.displayWarning(
            'Sample Range exceeded the Input Farm size and was auto-corrected to the maximum limit.',
            'Warning',
            undefined,  // no exception to pass
            () => {
           
              if (currenttransformer_sampleStart > this.totalInputRows) {
              this.viewModel.parameters.sampleStart = 1;
              }
              if (currenttransformer_sampleEnd > this.totalInputRows) {
                this.viewModel.parameters.sampleEnd = this.totalInputRows;
              }
            }
          );
          return;
        }
      const busyIndicator = this.showBusyDialog('Please wait...');
      try {
        let config = this.dataTransformConfigViewModel.dataTransformerConfig ?? new DataTransformerConfig();
  
        config.name = configName;
        config.organizationId = 1;
        config.dataSourceType = this.dataTransformConfigViewModel.dataSourceType;
        config.selectedIngestFarmGuid = this.dataTransformConfigViewModel.selectedIngestFarmGuid;
        
        // Save the Data Connectors
        config.dataConnectorMappings = this.dataTransformConfigViewModel.ingestConfigs
        .map ( ingestConfig =>
          new DataConnectorMapping(
            ingestConfig.id,
            ingestConfig.name,
            ingestConfig.targetDataFarm,
            ingestConfig.dataConnector.toDataConnector(),
            ingestConfig.columnMap
              .map(i => i.toColumnMapDefinition()),
              ingestConfig.guid, 
              ingestConfig.masterColumnMapGuid)
        );
  
        //console.log('saving config...');
        //console.log(this.dataTransformConfigViewModel);
  
        // Save Transforms
        config.transforms = this.dataTransformConfigViewModel.transforms.map(t => t.transform);
  
        // Save the transform
        //const transform = config.transforms.find(t => t.id === this.viewModel.transform?.id) ?? this.viewModel.transformViewModel.transform;
        const transform = this.viewModel.transformViewModel.transform;
        //console.log(transform);
        
        //const extractorConfig: AnonymizerTransformConfig = transform.transformConfig ?? this.viewModel.toAnonymizerTransformConfig();
        
        transform.transformConfig = this.viewModel.toTransformConfig();
        // transform.dataFarmName = this.viewModel.dataFarm.name;
        // transform.dataFarmType = this.viewModel.dataFarm.dataFarmType;
  
        // TODO: Maintain list of transforms for this config
        const existingTransform = config.transforms.find(t => t.guid === transform.guid);
        if (existingTransform) {
          config.transforms.splice(config.transforms.indexOf(existingTransform), 1);
        }      
  
        config.transforms.push(transform);
        // Save the ingest transforms
        //console.log(JSON.stringify(config));
  
        config = await this.configService.upsertConfig(config);
        //console.log(config);
        this.userData.setSelectedConfigJson(config);
        this.configViewModelService.setDataTransformConfigViewModel(new DataTransformConfigViewModel(config));
        this.userData.setSelectedTransform(this.dataTransformConfigViewModel.transforms.find(x=>x.guid=== this.userData.getSelectedTransform().guid));
        // SAve the current node status to Not RunConfigRequest.
        const selectedNode = this.userData.getSelectedNodeDetails();
        //const RefineryConfigJson = await this.configService.getRefineryConfigByGuidAsync(selectedNode.refineryConfigGuid);
        // //console.log('Refinery json in save = ', RefineryConfigJson) ;
        //RefineryConfigJson.nodes.filter(newNode => newNode.id == selectedNode.id)[0].data.nodeStatus = NodeRunStatus.NotRun
        //let RefineryJson = await this.configService.UpsertRefineryConfig(RefineryConfigJson);
  
        // var UpdateNodesStatus: UpdateNodesStatusRequest = new UpdateNodesStatusRequest(selectedNode.refineryConfigGuid, selectedNode.id, NodeRunStatus.PipelineModified )
        // let updateStatusreturn = await this.configService.updateUpcomingNodesStatus(UpdateNodesStatus);
  
        //Invoke the save current transformer cache api
       const activeTransformGuid = this.userData.getSelectedTransform().guid
       const userId = this.userData.getUserId()
       const orgId = this.userData.getOrgId()
       var saveCurrentTransformerCacheRequest: SaveCurrntTransfrmcacheRequest = new SaveCurrntTransfrmcacheRequest(userId, orgId, selectedNode.id, selectedNode.refineryConfigGuid, this.dataTransformConfigViewModel.selectedIngestFarmGuid, activeTransformGuid);
       await this.configService.saveCurrentTransformerCache(saveCurrentTransformerCacheRequest);
       await this.configService.getRefineryConfigByGuidAsync(this.userData.getRefineryId());
       this.getCacheStatus(); 
       //update preViewModel
        this.snapshotPreState();

       // this.cdRef.detectChanges();
        this.snackBar.open(`Successfully saved transform pipeline '${this.userData.getSelectedTransform().name}'`, 'Dismiss', {
          duration: 5000
        });
        busyIndicator.close();
  
      } catch (err) {
        busyIndicator.close();
        this.displayError(`Failed to save '${this.userData.getSelectedTransform().name}'`, 'Error', err);
      }
    }
  
    
    onSetDefaultRule(defaultfield:string){
      // if(defaultfield=="sourceColumn"){
      //   this.viewModel.rules.forEach(rule=>{
      //     rule.sourceColumn=this.viewModel.parameters.sourceColumn;
      //   })
      // }
      // else if(defaultfield=="targetColumn"){
      //   this.viewModel.rules.forEach(rule=>{
      //     rule.targetColumn=this.viewModel.parameters.targetColumn;
      //   })
      // }
    }
    totalRulesColumnDisplay(){
      //blank values
      this.viewModel.rules.forEach(rule=>{
        rule.rowHits=null;
      })
      if(this.viewModel.parameters.runAll){
        this.displayedColumns= [
          'actions',
          'index',
          'name',
          'fields',
          'anonType',
          'preservedTerms',
          'mapTerms',
          'ruleOption',
          'wordSepMode',
          'mapOnly',
          'matchCase',
          'findTerms',
          'andOr',
          'isEnabled',
          'sampleHits',
          'hits'];
        }else{
        this.displayedColumns= [
          'actions',
          'index',
          'name',
          'fields',
          'anonType',
          'preservedTerms',
          'mapTerms',
          'ruleOption',
          'wordSepMode',
          'mapOnly',
          'matchCase',
          'findTerms',
          'andOr',
          'isEnabled',
          'sampleHits',
          'hits'];
      }
      this.cdRef.detectChanges();
    }
    onToggleRulesColumnDisplay(){
      //this.totalRulesColumnDisplay();
    }
    onToggleMultiTarget(event: any){
      //this.viewModel.multiTargetColumn=event.checked;
    }
    onToggleSpaceSeparator(event: any){
      //this.viewModel.spaceSeparator=event.checked;
    }
    onToggleRemoveRedundant(event: any){
      //this.viewModel.removeRedundant=event.checked;
    }
    onParameterFormStatusChange(status: boolean) {
      this.isParameterFormValid = status;
    }

    checkContainsListLength(rule: any): boolean {
      return !rule.containsList || rule.containsList.length <= 1;
    }   
  
    onTabClick(event: MatTabChangeEvent): void {
      const selectedTabIndex = event.index;
      const selectedTabLabel = event.tab.textLabel;
      this.selectedIndex = selectedTabIndex;
   
      // Alert the tab index and label
     // alert(`Tab clicked: ${selectedTabLabel} (Index: ${selectedTabIndex})`);
     this.userData.setResultsTabClicked(false);
     if(selectedTabLabel.match("Output") && selectedTabIndex == 1) {
      this.userData.setOutputTabClicked(true)
      this.setOutputPreviewTabSlctnStatus();
     } else {
        this.userData.setOutputTabClicked(false);
        this.setInputPreviewFilterViewModel();
     }
    }
  
    setAnonymizerResultsTabClicked(): void {
      if(this.inputPrvwFilterViewModel.transfrmrInputprvwCacheKey.length > 0) {
        this.transformerInputPreviewCacheKey = this.inputPrvwFilterViewModel.transfrmrInputprvwCacheKey;
      }
      
      this.userData.setOutputTabClicked(false);
      this.userData.setResultsTabClicked(true);
      this.resetTransformerInputPrvwModelData();
      this.userData.setInputTabDataFrFilter(this.inputPrvwFilterViewModel);
      this.isResultsPanelExpanded = true;
      this.isPreviewPanelExpanded = false;
    }
  
    setAnonymizerPreviewTabClicked(): void {
      if(this.inputPrvwFilterViewModel.transfrmrInputprvwCacheKey.length > 0) {
        this.transformerInputPreviewCacheKey = this.inputPrvwFilterViewModel.transfrmrInputprvwCacheKey;
      }
      this.userData.setResultsTabClicked(false);
      this.userData.setOutputTabClicked(false);
      this.isResultsPanelExpanded = false;
      this.isPreviewPanelExpanded = true;
      if(this.selectedIndex == 0) {
        this.setInputPreviewFilterViewModel();
      }
      if(this.selectedIndex == 1) {
        this.setOutputPreviewTabSlctnStatus();
      }
    }
  
    setOutputPreviewTabSlctnStatus(): void {
      this.userData.setResultsTabClicked(false);
      this.userData.setOutputTabClicked(true);
      this.resetTransformerInputPrvwModelData();
      this.userData.setInputTabDataFrFilter(this.inputPrvwFilterViewModel);
    }
  
    setInputPreviewFilterViewModel() {
      this.inputPrvwFilterViewModel.previewType = "TransformerInput";
      this.setTransformerInputPrvwCacheKey();
      this.userData.setInputTabDataFrFilter(this.inputPrvwFilterViewModel)
    }
    
    setTransformerInputPrvwCacheKey() {
      if(this.transformerInputPreviewCacheKey.length > 0 && this.inputPrvwFilterViewModel.farmId.length > 0) {
        this.inputPrvwFilterViewModel.transfrmrInputprvwCacheKey = this.transformerInputPreviewCacheKey;
        this.userData.setInputTabDataFrFilter(this.inputPrvwFilterViewModel);
      }
    }
    resetInputPrvwViewModel() {
      this.inputPrvwFilterViewModel.farmId = "";
      this.inputPrvwFilterViewModel.collookupFarmId = "";
      this.inputPrvwFilterViewModel.nodeType = "";
      this.inputPrvwFilterViewModel.previewType = "TransformerInput";
      this.inputPrvwFilterViewModel.transfrmrInputprvwCacheKey = "";
    }
  
    resetTransformerInputPrvwModelData() {
      this.inputPrvwFilterViewModel.transfrmrInputprvwCacheKey = "";
      this.inputPrvwFilterViewModel.previewType = "";
    }
  
    get isValidateParameters(): boolean {
      return false;//!this.isParameterFormValid;
    }
    get isValidateAdvanceSettings(): boolean {
      return this.form.invalid;
    }
    onFixedPreservedCellClicked(contains: ColoredTextItem[],type:string): void {
      let title: string=`Fixed Preserved terms Chooser (`+type+`)`;
      let label: string="Preserved Terms";
      let placeholder: string="Enter Value";
      let fieldType: string ="autocomplete";
      let isDuplicateRemoved: boolean =true;
      let canAddNewAutocomplete: boolean =true;
      let options: string[] = [];
      let dialogWidth: string='400px'
      if(type=="Name"){
        options=this.fixedTermsName.default.split(";");
      } else if(type=="Category"){
        options=this.fixedTermsCategory.default.split(";");
      }else if(type=="Location"){
        options=this.fixedTermsLocation.default.split(";");
      }else if(type=="Details"){
        options=this.fixedTermsDetails.default.split(";");
      }else if(type=="URL"){
        options=this.fixedTermsURL.default.split(";");
      }
      this.showTextEditorDialogOption(title, label,placeholder,fieldType,isDuplicateRemoved,canAddNewAutocomplete,options,dialogWidth, 
        contains,
        async (items: ColoredTextItem[],eventname:string) => {
          if(eventname=='save'){
            if(type=="Name"){
              this.viewModel.fixedTermsName = items;
            } else if(type=="Category"){
              this.viewModel.fixedTermsCategory = items;
            }else if(type=="Location"){
              this.viewModel.fixedTermsLocation = items;
            }else if(type=="Details"){
              this.viewModel.fixedTermsDetails = items;
            }else if(type=="URL"){
              this.viewModel.fixedTermsURL = items;
            }
          }
      });
    }
    
    onRuleFieldSelectCellClicked(rule: AnonymizerRuleViewModel): void {
      let title: string=`Field Chooser Rule ${rule.index}`;
      let label: string="Field Name";
      let placeholder: string="Field Name";
      let fieldType: string ="dropdown";
      let isDuplicateRemoved: boolean =true;
      let canAddNewAutocomplete: boolean =false;
      var options: string[] = [];
      let dialogWidth: string='400px'
      
      //let sourceColumnTexts = new Set(this.viewModel.sourceColumns.map(c => c.text));// Use Set for faster lookups
      if(rule.anonType==AnonType.Email){
        var optionsEmails=["userName","userFullName","userLastName","userFirstName","userId","emailAddress"];
        this.inputDataFarmPreviewTable.displayedColumnInfos.filter(col=>optionsEmails.includes(col.name)).forEach(map=>{
          options.push(map.name);
        });
      }else if(rule.anonType==AnonType.Integer){
        this.inputDataFarmPreviewTable.displayedColumnInfos.filter(col=>(this.getDataType(col.pydataType)=="int")).forEach(map=>{
          options.push(map.name);
        });
      }else if(rule.anonType==AnonType.Decimal){
        this.inputDataFarmPreviewTable.displayedColumnInfos.filter(col=>this.getDataType(col.pydataType)=="float").forEach(map=>{
          options.push(map.name);
        });
      }else if(rule.anonType==AnonType.Date){
        this.inputDataFarmPreviewTable.displayedColumnInfos.filter(col=>(this.getDataType(col.pydataType)=="datetime")).forEach(map=>{
          options.push(map.name);
        });
      }else if(rule.anonType==AnonType.Time){
        this.inputDataFarmPreviewTable.displayedColumnInfos.filter(col=>(this.getDataType(col.pydataType)=="datetime")).forEach(map=>{
          options.push(map.name);
        });
      }else {
        this.inputDataFarmPreviewTable.displayedColumnInfos.filter(col=>(this.getDataType(col.pydataType)=="string")).forEach(map=>{
          options.push(map.name);
        });
      }
      // Get unique values
      var options = Array.from(new Set(options)).sort();
      this.showTextEditorDialogOption(title, label,placeholder,fieldType,isDuplicateRemoved,canAddNewAutocomplete,options,dialogWidth, 
        rule.fields,
        async (items: ColoredTextItem[],eventname:string) => {
        if(eventname=='save'){
          var validate=true;
          if(rule.anonType==AnonType.Email){
            if (items.length !== 2) {
              validate=false;
              this.displayWarning(TransformRuleViewModel.ruleMessage(rule, "Fields: There must be two fields for the Email Anonymizer: The Name Field and the Target Email Field."),"Please fix the validation error."
              ,"", onClosed=> {
                this.onRuleFieldSelectCellClicked(rule);
              });
            }
          }
          if(validate){
            rule.fields = items;
          }
        }
      });
    }
    
    onRulePreservedCellClicked(rule: AnonymizerRuleViewModel): void {
      let title: string=`Preserved terms Chooser (`+AnonTypeUtil.toString(rule.anonType)+`) Rule ${rule.index}`;
      let label: string="Enter Term";
      let placeholder: string="Enter Term";
      let fieldType: string ="edit";
      let isDuplicateRemoved: boolean =true;
      let canAddNewAutocomplete: boolean =true;
      let options: string[] = [];
      let dialogWidth: string='400px'
      let showRefresh: boolean =true;
      let refreshTooltip: string = 'Download Defaults';
      
      if(rule.anonType==AnonType.Name){
        fieldType="autocomplete";
        options=this.fixedTermsName.default.split(";");
      }
      else if(rule.anonType==AnonType.Category){
        fieldType="autocomplete";
        options=this.fixedTermsCategory.default.split(";");
      }
      else if(rule.anonType==AnonType.Details){
        fieldType="autocomplete";
        options=this.fixedTermsDetails.default.split(";");
      }
      else if(rule.anonType==AnonType.Location){
        fieldType="autocomplete";
        options=this.fixedTermsLocation.default.split(";");
      }
      else if(rule.anonType==AnonType.URL){
        fieldType="autocomplete";
        options=this.fixedTermsURL.default.split(";");
      }
      else if(rule.anonType==AnonType.Date){
        fieldType="autocomplete";
        options=['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
      }
      else if(rule.anonType==AnonType.Email){
        fieldType="autocomplete";
        options=['dtr.com','evidant.org'];
      }

      this.showTextEditorDialogOption(title, label,placeholder,fieldType,isDuplicateRemoved,canAddNewAutocomplete,options,dialogWidth, 
        rule.preservedTerms,
        async (items: ColoredTextItem[],eventname:string) => {
        if(eventname=='save'){
          // Validate Rules Table for Email
          var validate=true;
          if(rule.anonType==AnonType.Email){
            if (items.length !== 1) {
              validate=false;
              this.displayWarning(TransformRuleViewModel.ruleMessage(rule, "Extensions: This is a single entry only.  The email domain is required in this field in the form domain.ext (like evidant.com)"),"Please fix the validation error."
              ,"", onClosed=> {
                this.onRulePreservedCellClicked(rule);
              });
            }else
            
            if(items.length == 1){
              // Check if the preserved term is a valid domain name (contains a dot but not "http", "www")
              const domain = items[0].text;
              const domainRegex = /^(?!.*(http|www))([a-zA-Z0-9.-]+\.[a-zA-Z]{2,})$/;

              if (!domainRegex.test(domain)) {
                validate=false;
                this.displayWarning(TransformRuleViewModel.ruleMessage(rule, "Extensions: This is a single entry only.  The email domain is required in this field in the form domain.ext (like evidant.com)"+" fields : "+items[0].text),"Please fix the validation error."
                ,"", onClosed=> {
                  this.onRulePreservedCellClicked(rule);
                });
              }
            }
          }
          if(validate){
            rule.preservedTerms = items;
          }
        }else if(eventname=='refresh'){
          console.log("eventname ",eventname);
          if(rule.anonType==AnonType.Name){
            let colorIndex = 0;
            rule.preservedTerms=this.fixedTermsName.default.split(";").map(r => new ColoredTextItem(r, NamedColorList[colorIndex++]));
          }
          else if(rule.anonType==AnonType.Category){
            let colorIndex = 0;
            rule.preservedTerms=this.fixedTermsCategory.default.split(";").map(r => new ColoredTextItem(r, NamedColorList[colorIndex++]));
          }
          else if(rule.anonType==AnonType.Details){
            let colorIndex = 0;
            rule.preservedTerms=this.fixedTermsDetails.default.split(";").map(r => new ColoredTextItem(r, NamedColorList[colorIndex++]));
          }
          else if(rule.anonType==AnonType.Location){
            let colorIndex = 0;
            rule.preservedTerms=this.fixedTermsLocation.default.split(";").map(r => new ColoredTextItem(r, NamedColorList[colorIndex++]));
          }
          else if(rule.anonType==AnonType.URL){
            let colorIndex = 0;
            rule.preservedTerms=this.fixedTermsURL.default.split(";").map(r => new ColoredTextItem(r, NamedColorList[colorIndex++]));
          }
          // Update dialog items live
          items.length = 0;
          rule.preservedTerms.forEach(x => items.push(x));
          return;
        }
      },showRefresh,refreshTooltip);
    }
    
    onRuleFindTermsCellClicked(rule: AnonymizerRuleViewModel): void {
      let title: string=`Match value (Find in Rows) Rule ${rule.index}`;
      let label: string="Enter Value";
      let placeholder: string="Enter Value";
      let fieldType: string ="edit";
      let isDuplicateRemoved: boolean =true;
      let canAddNewAutocomplete: boolean =true;
      let options: string[] = [];
      let dialogWidth: string='400px'
      this.showTextEditorDialogOption(title, label,placeholder,fieldType,isDuplicateRemoved,canAddNewAutocomplete,options,dialogWidth, 
        rule.findTerms,
        async (items: ColoredTextItem[],eventname:string) => {
          if(eventname=='save'){
            rule.findTerms = items;
          }
      });
    }

    onFindReplaceCellClicked(rule: AnonymizerRuleViewModel): void {
      let title: string=`Chooser (Find & Replace): Rule ${rule.index}${rule.ruleName ? ' - ' + rule.ruleName : ''}`;
      let labelFind: string="Find";
      let labelReplace: string="Replace";
      let placeholderFind: string="Enter find";
      let placeholderReplace: string="Enter replace";
      let fieldType: string="edit";
      let isDuplicateRemoved: boolean=false;
      let canAddNewAutocomplete: boolean=false;
      let optionsFind: OptionItemDataType[]=[];
      let optionsReplace: OptionItemDataType[]=[];
      let validateboth: boolean=false;
      let isDataTypeCheck: boolean=false;
      let dialogWidth: string='650px';
      this.showFindReplaceEditorDialogOption(title,labelFind,labelReplace,placeholderFind,placeholderReplace,fieldType,isDuplicateRemoved,canAddNewAutocomplete,optionsFind,optionsReplace,validateboth,isDataTypeCheck,dialogWidth,
        [...rule.mapTerms],
        async (items: ColoredTextFindReplaceItem[],eventname:string) => {
          if(eventname=='save'){
            rule.mapTerms = items;
          }
      });
    }

    isDisabledType(anonType: AnonType): boolean {
      return [
       // AnonType.Email,
        //AnonType.JoinID,
        AnonType.Phone,
        AnonType.Integer,
        AnonType.Decimal,
        AnonType.ID,
        AnonType.Date,
        AnonType.Time
      ].includes(anonType);
    }

    onAnonTypeChange(rule: AnonymizerRuleViewModel) {
      const group1 = [
        AnonType.Details,
        AnonType.Category,
        AnonType.URL
      ];

      const group2 = [
        AnonType.Date,
        AnonType.Time
      ];

      const isSameGroup =
        (group1.includes(rule.preAnonType) && group1.includes(rule.anonType)) ||
        (group2.includes(rule.preAnonType) && group2.includes(rule.anonType));
      //console.log("rule.preAnonType ",rule.preAnonType," rule.anonType ",rule.anonType," isSameGroup ",isSameGroup);
      // ✅ Skip confirm if within same group
      if (isSameGroup) {
        rule.preAnonType = rule.anonType;
        //console.log("rule.preAnonType1 ",rule.preAnonType)
        if(rule.anonType==AnonType.Date){
          rule.ruleOption=RuleOptions.Decade;
        }else if(rule.anonType==AnonType.Time){
          rule.ruleOption=RuleOptions.TimeShift2;
          rule.wordSepMode=WordSepMode.TwoHours;
        }else if(rule.anonType==AnonType.URL){
          rule.ruleOption=RuleOptions.Generic;
          rule.wordSepMode=WordSepMode.slash;
        }else if(rule.anonType==AnonType.Details || rule.anonType==AnonType.Category){
          rule.ruleOption=RuleOptions.Generic;
          rule.wordSepMode=WordSepMode.space;
        }
        
        return;
      }

      const isSpecialType =rule.anonType === AnonType.Details || rule.anonType === AnonType.Category || rule.anonType === AnonType.URL;
      //if(!isSpecialType){
      if(rule.fields.length>0 || rule.preservedTerms.length>0 || rule.mapTerms.length>0){
        this.showConfirmDialog(
            'Change Confirmation', 
            'Changing the Anonymizer Type will clear all current parameters in this rule.', 
            (confirmed) => {
                if (confirmed) {
                    rule.fields = [];
                    rule.preservedTerms = [];
                    rule.mapTerms = [];
                    rule.preAnonType=rule.anonType;
                } else {
                    rule.anonType = rule.preAnonType; // Revert if canceled
                }
            }
        );
      }
      else{
        rule.preAnonType=rule.anonType; // for Revert save 1st time value
      }
      //}
      //set default value for Email dtr.com
      if(rule.anonType==AnonType.Email && rule.preservedTerms.length==0){
        var pt=new ColoredTextItem("dtr.com",NamedColorList[0]);
        rule.preservedTerms.push(pt);
      }else if(rule.anonType==AnonType.Name){
        rule.ruleOption=RuleOptions.US;
        rule.wordSepMode=WordSepMode.LastFirst;
      }else if(rule.anonType==AnonType.JoinID){
        rule.ruleOption=RuleOptions.Keep;
      }else if(rule.anonType==AnonType.Location){
        rule.ruleOption=RuleOptions.US;
      }else if(rule.anonType==AnonType.Date){
        rule.ruleOption=RuleOptions.Decade;
      }else if(rule.anonType==AnonType.Time){
        rule.ruleOption=RuleOptions.TimeShift2;
        rule.wordSepMode=WordSepMode.TwoHours;
      }
      
      console.log(rule.anonType,isSpecialType);
      if(isSpecialType){
        if(![AnonType.Details, AnonType.Category, AnonType.URL].includes(rule.preAnonType)){
          rule.ruleOption=RuleOptions.Generic;
          rule.matchCase=true;
          if(rule.anonType==AnonType.Details || rule.anonType==AnonType.Category){
            rule.wordSepMode=WordSepMode.space;
          }else if(rule.anonType==AnonType.URL){
            rule.wordSepMode=WordSepMode.slash;
          }
        }else{
          rule.ruleOption=RuleOptions.Generic;
          if(rule.anonType==AnonType.Details || rule.anonType==AnonType.Category){
            rule.wordSepMode=WordSepMode.space;
          }else if(rule.anonType==AnonType.URL){
            rule.wordSepMode=WordSepMode.slash;
          }
        }
      }
    }
    
  async setDefaultValues(transformType:TransformType): Promise<void>{
    const selectedNode=this.userData.getSelectedNodeDetails();
    const masterconfig=this.userData.getMasterTransformers().find(x=>x.id==transformType);
    var parameters=masterconfig.parameters.find(x=>x.farmtypeid==selectedNode.farmtypeid);
    if(parameters){
      var params=parameters.parameters;
      //other parameters
        
      //advanced settings parameters
      this.threads=params.find(x=>x.jsonobject=='threads');
      this.fixedTermsName=params.find(x=>x.jsonobject=='fixedTermsName');
      this.fixedTermsCategory=params.find(x=>x.jsonobject=='fixedTermsCategory');
      this.fixedTermsLocation=params.find(x=>x.jsonobject=='fixedTermsLocation');
      this.fixedTermsDetails=params.find(x=>x.jsonobject=='fixedTermsDetails');
      this.fixedTermsURL=params.find(x=>x.jsonobject=='fixedTermsURL');
      this.caseName=params.find(x=>x.jsonobject=='caseName');
      this.caseCategory=params.find(x=>x.jsonobject=='caseCategory');
      this.caseLocation=params.find(x=>x.jsonobject=='caseLocation');
      this.caseDetails=params.find(x=>x.jsonobject=='caseDetails');
      this.caseURL=params.find(x=>x.jsonobject=='caseURL');
      //check this is first this.viewModel.sampleEnd =0
      if((this.viewModel.sampleEnd-1)==0 || isNaN(this.viewModel.sampleEnd)){
        //advanced settings parameters
          if(this.threads.default!=""){
            this.viewModel.threads=Number(this.threads.default);
          }
          //DT-3142 no default from starting
          if(this.fixedTermsName.default!=""){
            let colorIndex = 0;
            this.viewModel.fixedTermsName=[];//this.fixedTermsName.default.split(";").map(r => new ColoredTextItem(r, NamedColorList[colorIndex++]));
          }
          if(this.fixedTermsCategory.default!=""){
            let colorIndex = 0;
            this.viewModel.fixedTermsCategory=[];//this.fixedTermsCategory.default.split(";").map(r => new ColoredTextItem(r, NamedColorList[colorIndex++]));
          }
          if(this.fixedTermsLocation.default!=""){
            let colorIndex = 0;
            this.viewModel.fixedTermsLocation=[];//this.fixedTermsLocation.default.split(";").map(r => new ColoredTextItem(r, NamedColorList[colorIndex++]));
          }
          if(this.fixedTermsDetails.default!=""){
            let colorIndex = 0;
            this.viewModel.fixedTermsDetails=[];//this.fixedTermsDetails.default.split(";").map(r => new ColoredTextItem(r, NamedColorList[colorIndex++]));
          }
          if(this.fixedTermsURL.default!=""){
            let colorIndex = 0;
            this.viewModel.fixedTermsURL=[];//this.fixedTermsURL.default.split(";").map(r => new ColoredTextItem(r, NamedColorList[colorIndex++]));
          }
          this.viewModel.caseName=this.stringToBoolean(this.caseName.default);
          this.viewModel.caseCategory=this.stringToBoolean(this.caseCategory.default);
          this.viewModel.caseLocation=this.stringToBoolean(this.caseLocation.default);
          this.viewModel.caseDetails=this.stringToBoolean(this.caseDetails.default);
          this.viewModel.caseURL=this.stringToBoolean(this.caseURL.default);
      }
    }else{
      //advanced settings parameters
      // this.bufferRows.label="Buffer Rows";this.bufferRows.jsonobject="bufferRows";this.bufferRows.min=0;this.bufferRows.max=10000000;
      // this.threads.label="Threads (0 > Auto)";this.threads.jsonobject="threads";this.threads.min=0;this.threads.max=64;
      // this.resetRows.label="Reset Row Numbers";this.resetRows.jsonobject="resetRows";
    }
  }
  async removeInvalidValues(): Promise<void>{
    //other parameters
    //advanced settings parameters
  }
  async loadImportTransformer(transform: any): Promise<void>{
    const busyIndicator = this.showBusyDialog('Please wait...');
    try{
      if(this.userData.getSelectedNodeDetails().farmtypeid!=transform.farmType){
        this.displayError("Current DataFarmType is " + DataFarmTypeUtil.toString(this.userData.getSelectedNodeDetails().farmtypeid) + ". But you are trying to load a different DataFarmType: " + DataFarmTypeUtil.toString(transform.farmType),"Error");
        return;
      }else if(this.transformType!=transform.transformType){
        this.displayError("Current transform is " + TransformTypeUtil.toString(this.transformType) + ". But you are trying to load a different transform type: " + TransformTypeUtil.toString(transform.transformType),"Error");
        return;
      }
      var ctranformconfig=this.dataTransformConfigViewModel.transforms.find(x=>x.guid=== this.userData.getSelectedTransform().guid);
      ctranformconfig.transform.transformConfig=transform;
      var newmodel =new AnonymizerViewModel(this.dataDictService,this.configService,this.dataTransformConfigViewModel,ctranformconfig);
      // force new object reference for UI refresh
      this.viewModel.rules=[];
      this.viewModel.rules=[...newmodel.rules];
      this.isRuleSetEmpty = this.viewModel.rules.length === 0;
      this.dataSource.data = this.viewModel.rules;
      //update Parameters
      this.viewModel.parameters.sortInfo=newmodel.parameters.sortInfo;
      this.viewModel.parameters.sampleStart =newmodel.parameters.sampleStart;
      this.viewModel.parameters.sampleEnd =newmodel.parameters.sampleEnd;
      this.viewModel.parameters.runAll =newmodel.parameters.runAll;
      //other parameters
      
      //advanced settings parameters
      this.viewModel.threads = newmodel.threads;
      this.viewModel.caseName = newmodel.caseName;
      this.viewModel.caseCategory = newmodel.caseCategory;
      this.viewModel.caseLocation = newmodel.caseLocation;
      this.viewModel.caseDetails = newmodel.caseDetails;
      this.viewModel.caseURL = newmodel.caseURL;
      this.viewModel.fixedTermsName = newmodel.fixedTermsName;
      this.viewModel.fixedTermsCategory = newmodel.fixedTermsCategory;
      this.viewModel.fixedTermsLocation = newmodel.fixedTermsLocation;
      this.viewModel.fixedTermsDetails = newmodel.fixedTermsDetails;
      this.viewModel.fixedTermsURL = newmodel.fixedTermsURL;
      //update rule table height
      if(this.viewModel.rules.length<=10){
        this.minrowcount=this.viewModel.rules.length;
      }else{
        this.minrowcount=10;
      }
      this.maxrowcount=this.viewModel.rules.length;
    }catch (err) {
      this.displayError(`Failed to save import transformer`, 'Error', err);
    }finally {
      busyIndicator.close();
    }
  }
  onLoadreset(type:string): void {
    if(type=="Name"){
      let colorIndex = 0;
      this.viewModel.fixedTermsName=this.fixedTermsName.default.split(";").map(r => new ColoredTextItem(r, NamedColorList[colorIndex++]));
    } else if(type=="Category"){
      let colorIndex = 0;
      this.viewModel.fixedTermsCategory=this.fixedTermsCategory.default.split(";").map(r => new ColoredTextItem(r, NamedColorList[colorIndex++]));
    }else if(type=="Location"){
      let colorIndex = 0;
      this.viewModel.fixedTermsLocation=this.fixedTermsLocation.default.split(";").map(r => new ColoredTextItem(r, NamedColorList[colorIndex++]));
    }else if(type=="Details"){
      let colorIndex = 0;
      this.viewModel.fixedTermsDetails=this.fixedTermsDetails.default.split(";").map(r => new ColoredTextItem(r, NamedColorList[colorIndex++]));
    }else if(type=="URL"){
      let colorIndex = 0;
      this.viewModel.fixedTermsURL=this.fixedTermsURL.default.split(";").map(r => new ColoredTextItem(r, NamedColorList[colorIndex++]));
    }
  }
  onDelete(type:string): void {
    if(type=="Name"){
      this.viewModel.fixedTermsName=[];
    } else if(type=="Category"){
      this.viewModel.fixedTermsCategory=[];
    }else if(type=="Location"){
      this.viewModel.fixedTermsLocation=[];
    }else if(type=="Details"){
      this.viewModel.fixedTermsDetails=[];
    }else if(type=="URL"){
      this.viewModel.fixedTermsURL=[];
    }
  }
}
